import * as React from "react";

import styles from "./ProgressBar.module.css";

export interface ProgressBarProps {
  /** 0..100 */
  percent: number;
  /** track width in px; omit to fill available width */
  width?: number;
  showLabel?: boolean;
  size?: "sm" | "md";
  /** Крупный лейбл (11.5px) — для свёрнутого хедера дерева. */
  largeLabel?: boolean;
  className?: string;
}

/** Color-coded completion bar: 0% red, 100% green, in-between amber. */
export const barColor = (percent: number): string => {
  if (percent >= 100) return "var(--progress-green)";
  if (percent <= 0) return "var(--progress-red)";
  return "var(--progress-amber)";
};

/**
 * Цвет процента рядом с полосой. Пороги те же, что у barColor, но оттенки
 * темнее: заливка оптимизирована под 6px полоску на сером треке, текст —
 * под чтение на белом. В макете это две разные тройки значений.
 */
export const labelColor = (percent: number): string => {
  if (percent >= 100) return "var(--progress-label-green)";
  if (percent <= 0) return "var(--progress-label-red)";
  return "var(--progress-label-amber)";
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percent, width, showLabel, size = "sm", largeLabel, className,
}) => {
  const pct = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className={`${styles.wrap}${className ? ` ${className}` : ``}`}>
      <div
        className={`${styles.track} ${styles[size]}${pct <= 0 ? ` ${styles.empty}` : ``}`}
        style={width ? { width, flex: "none" } : undefined}
      >
        <div className={styles.fill} style={{ width: `${pct}%`, background: barColor(pct) }} />
      </div>
      {showLabel && (
        <span
          className={`${styles.label}${largeLabel ? ` ${styles.lg}` : ``}`}
          style={{ color: labelColor(pct) }}
        >
          {pct}%
        </span>
      )}
    </div>
  );
};
